import { get } from "@insite/client-framework/Services/ApiService";
import { PricingStatusModel } from "./PricingStatusModel";

const getCustomerPriceingUrl = "/api/v2/account/customerstatus?CustomerNumber=";

export async function getCustomerPriceingStatus(userID: string) {
    if (userID) {
        const customerId = userID.split("-")[0];
        return get<PricingStatusModel>(`${getCustomerPriceingUrl}${customerId}`);
    }
}
